<template>
  <v-dialog v-model="open" max-width="500px" persistent>
    <template v-slot:activator="{ on, attrs }">
      <location-info-item
        icon-action="mdi-pencil-outline"
        icon="mdi-text-short"
        title="Nome"
        :subtitle="formData.location_name"
        titleClass="title"
        v-bind="attrs"
        v-on="on"
      />
    </template>

    <v-card>
      <v-toolbar elevation="0">
        <v-card-title class="ml-0 pl-1">
          Nomes das empresas
        </v-card-title>

        <v-spacer />

        <v-btn icon @click="open = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>

      <v-card-text>
        Insira o nome do negócio da forma como ele aparece para os clientes no
        mundo real.
      </v-card-text>

      <v-card-text>
        <v-form ref="form" v-model="formValid" lazy-validation @submit="e => e.preventDefault()">
          <v-text-field
            v-model="formData.location_name"
            :counter="100"
            :rules="nameRules"
            required
            outlined
            v-on:keyup.enter="() => callAction()"
          ></v-text-field>
        </v-form>
      </v-card-text>

      <v-divider />

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="secondary" text @click="cancel">
          Cancelar
        </v-btn>
        <v-btn :loading="loading" color="primary" text @click="callAction">
          Ok
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import LocationInfoItem from '@/views/Locations/Components/LocationInfoItem';
import { mapState } from 'vuex';
import { TYPE_UPDATE_LOCATION_LOCATION_NAME } from '@/constants/tasks';

export default {
  name: 'LocationNameBulkUpdateModal',
  components: {
    LocationInfoItem
  },
  computed: {
    ...mapState({
      location: (state) => state.locations.location
    })
  },
  methods: {
    cancel() {
      this.open = false
      this.resetData()
    },
    resetData() {
      const { location_name } = this.formDataOriginal
      this.formData.location_name = location_name
      if (this.bulkUpdate) {
        this.$emit('removePayload', 'location_name')
      }
    },
    callAction: async function() {
      if (this.$refs.form.validate()) {
        this.$emit('savePayload', 'location_name', this.formData.location_name)
        this.name = this.formData.location_name
        this.validNameLocation = true
        this.open = false
      }
      this.validNameLocation = false
    },
    changeScheduleDate(data) {
      this.formData.schedule_start = data.schedule_start
      this.formData.schedule_end = data.schedule_end
    }
  },
  data: () => ({
    open: false,
    loading: false,
    formValid: true,
    validNameLocation: false,
    formData: {
      schedule_type: TYPE_UPDATE_LOCATION_LOCATION_NAME,
      schedule_start: '',
      schedule_end: '',
      location_name: ''
    },
    formDataOriginal: {},
    nameRules: [
      (v) => !!v || 'O nome da empresa é obrigatório',
      (v) =>
        (v && v.length <= 100) || 'Nome precisa ter menos de 100 caracteres'
    ],
    name: null
  })
};
</script>
